import React, { PropTypes } from 'react';
import ErrorContainer from '../ErrorContainer';
import LiveInputField from './LiveInputField';
import LiveDatePicker from '../LiveDatePicker';

class Input extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    object: PropTypes.object,
    visited: PropTypes.bool,
    required: PropTypes.bool,
    value: PropTypes.any,
    errorLabelStyle: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  render() {
    return (
      <ErrorContainer {...this.props}
                      errorLabelStyle={{...this.props.errorLabelStyle}}
                      labelStyle={{position: 'relative'}}>
        {this._renderField()}
      </ErrorContainer>
    );
  }

  _renderField() {
    let {onChange, value, ...other} = this.props;

    switch(this.props.type) {
      case 'date':
        return (
          <LiveDatePicker onChange={onChange}
                          value={value}
          />
        );
      default:
        return (
          <LiveInputField value={value}
                          onChange={onChange}
                          {...other}
                          style={{width: '100%'}}
                          autoComplete="false"
          />);
    }
  }
}

Input.defaultProps = {
  required: false,
  visited: false,
  label: ''
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/form/Input/Input.jsx